import React from 'react'
import { FormControlLabel, FormControl, RadioGroup, Radio } from '@material-ui/core'
import { Field } from 'react-final-form'
import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
	label: {
		color: theme.palette.primary.main,
	},
	root: {
		display: 'inline',
		color: theme.palette.primary.main,
		'&$checked': {
			color: theme.palette.primary.main,
		},
	},
	test: {
		height: '40px',
	},
	block: {
		display: 'block',
	},
}))

export default function InputRadio({ name, children, ...props }) {
	const classes = useStyles()
	return (
		<FormControl>
			<RadioGroup name={name} className={classes.block} {...props}>
				{children}
			</RadioGroup>
		</FormControl>
	)
}

export function TotalRadio({ value, label, name, image, ...props }) {
	const classes = useStyles()
	return (
		<FormControlLabel
			classes={{
				label: classes.label,
			}}
			label={label}
			control={
				<Field
					name={name}
					value={value}
					type="radio"
					render={({ input, meta }) => (
						<>
							{image && <img src={image} alt={value} />}
							<Radio
								classes={{
									root: classes.root,
									checked: classes.checked,
								}}
								className={classes.test}
								color="primary"
								value={value}
								disableRipple
								{...input}
							/>
						</>
					)}
				/>
			}
			{...props}
		/>
	)
}
